import { supabase } from '@/integrations/supabase/client';

/**
 * Toggle favorite status for an asset
 * @param assetId - The asset ID to toggle
 * @returns The new favorite status (true = favorited, false = unfavorited)
 */
export async function toggleAssetFavorite(assetId: string): Promise<boolean> {
  // First get current status
  const { data: asset, error: fetchError } = await supabase
    .from('app_assets')
    .select('is_favorited')
    .eq('id', assetId)
    .single();

  if (fetchError) throw fetchError;

  const newStatus = !asset.is_favorited;

  // Update the status
  const { error: updateError } = await supabase
    .from('app_assets')
    .update({ is_favorited: newStatus })
    .eq('id', assetId);

  if (updateError) throw updateError;

  return newStatus;
}

/**
 * Get favorite status for multiple assets (batch query)
 */
export async function getAssetsFavoriteStatus(assetIds: string[]): Promise<Record<string, boolean>> {
  const { data, error } = await supabase
    .from('app_assets')
    .select('id, is_favorited')
    .in('id', assetIds);

  if (error) throw error;

  return Object.fromEntries(
    data?.map(asset => [asset.id, asset.is_favorited]) || []
  );
}
